import { gql } from '@apollo/client';

const GET_REPORTING_GROUPS_QUERY = gql`
  {
    reportingGroups {
      key: id
      text: fieldName
    }
  }
`;

export default GET_REPORTING_GROUPS_QUERY;
